window.addEventListener('load', () => {
    ContactForm();
    EatingMenu();
}, false);